import React from 'react';

import { configs } from '$configs';
import { SORT, COLORS } from '$gbusiness/enums';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { defaultDataSource, defaultStyles, TableModel } from '$gbusiness/models/table';
import CellModel from '$gbusiness/models/cell';
import { deriveRawToDiscount } from '$fbusiness/models/discount';
import { currency, percentage } from '$gbusiness/helpers/util';
import { Button } from '@mui/material';

export const DISCOUNT_TABLE_CONFIG: TableModel = {
  dataSource: {
    ...defaultDataSource,
    endpoint: configs.api.discount,
    method: 'GET',
    deriveToModel: deriveRawToDiscount,
    defaultSortKey: 'createdAt',
    defaultSortOrder: SORT.DSC,
    shouldVirtualize: false,
    pageSize: 20,
  },
  styles: {
    ...defaultStyles,
    color: COLORS.LIGHT,
    fontSize: '1em',
    minWidth: 300,
    maxWidth: 800,
    cellPadding: ` 8px 4px`,
    isStripped: true,
  },
  filter: {
    color: COLORS.PRIMARY,
  },
};

export const DISCOUNT_TABLE = (): Array<CellModel> => [
  {
    label: 'SCREEN.DISCOUNTS.COLS.NAME',
    value: 'name',
    alwaysShow: true,
    sortable: SORT.ASC,
    width: 400,
  },
  {
    label: 'SCREEN.DISCOUNTS.COLS.RATE',
    value: 'settings.rate',
    component: (row) => <div>{row.isFlat ? currency(row.amount) : percentage(row.amount)}</div>,
    sortable: SORT.ASC,
    width: 200,
  },
  {
    label: '',
    value: 'settings.rate',
    component: (row) => <div>{row.isFlat ? currency(row.amount) : percentage(row.amount)}</div>,
    sortable: SORT.ASC,
    width: 200,
  },
  {
    label: 'SCREEN.ITEMS.COLS.ACTION',
    value: '',
    className: 'action nowrap',
    align: 'center',
    component: (row, actions) => {
      return (
        <Button
          className="left"
          color="secondary"
          fullWidth
          onClick={(e) => actions.handlePopoverOpen(e, row)}>
          <MoreHorizIcon />
        </Button>
      );
    },
    width: 100,
  },
];
